import { useState, useEffect } from 'react';
import { CognitoService } from '../auth/CognitoService';
import LoginPage from './LoginPage';

interface Props {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: Props) {
  // null = checking, true = authenticated, false = not authenticated
  const [authenticated, setAuthenticated] = useState<boolean | null>(
    CognitoService.isEnabled() ? null : true
  );

  useEffect(() => {
    if (!CognitoService.isEnabled()) return;
    CognitoService.getAccessToken().then(token => {
      setAuthenticated(token !== null);
    });
  }, []);

  if (authenticated === null) return null; // brief loading flash

  if (!authenticated) {
    return <LoginPage onLogin={() => setAuthenticated(true)} />;
  }

  return <>{children}</>;
}
